import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import Global from '../../../store/global-selectors';
import PrintDocumentButton from '../../../components/print-document-button';

import { CustomsForm } from './components/customs-form';
import { Label } from './components/label';
import { PackingSlip } from './components/packing-slip';
import { PickList } from './components/pick-list';

export const ShipmentDetailsPrintDocumentButton = ({ data }) => {
  const fulfillmentPlan = data?.fulfillmentPlan ?? emptyObject;
  const fulfillments = data?.fulfillments ?? emptyArray;
  const fulfillmentPlanId = fulfillmentPlan?.fulfillmentPlanId;
  const packingSlipTemplateId = fulfillmentPlan?.packingSlipTemplateId;
  const shipFroms = useSelector(Global.selectSellerShipFroms);
  const userHasShippingRole = useSelector(Global.selectUserhasShippingRole);

  return (
    <PrintDocumentButton theme='white'>
      <PackingSlip
        fulfillmentPlan={fulfillmentPlan}
        packingSlipTemplateId={packingSlipTemplateId}
        userHasShippingRole={userHasShippingRole}
      />
      <Label fulfillmentPlanId={fulfillmentPlanId} fulfillments={fulfillments} userHasShippingRole={userHasShippingRole} />
      <PickList fulfillmentPlanId={fulfillmentPlanId} />
      <CustomsForm
        fulfillmentPlan={fulfillmentPlan}
        fulfillments={fulfillments}
        shipFroms={shipFroms}
        userHasShippingRole={userHasShippingRole}
      />
    </PrintDocumentButton>
  );
};

ShipmentDetailsPrintDocumentButton.propTypes = {
  data: PropTypes.shape({
    fulfillmentPlan: PropTypes.shape({
      fulfillmentPlanId: PropTypes.string,
      packingSlipTemplateId: PropTypes.string,
    }),
    fulfillments: PropTypes.array,
  }).isRequired,
};
